import type { StoreSummary } from '~/services/api/generated'

export const formatStoreAddress = (
  store: Pick<StoreSummary, 'address' | 'city' | 'state' | 'zip'>
): string => {
  const region = [store.state, store.zip].filter((part) => part !== null && part !== '').join(' ')
  return [store.address, store.city, region]
    .filter((part) => part !== null && part !== '')
    .join(', ')
}
